import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GamePlayService } from '../game-play/gamePlayService.service';
import { MatchGameService } from '../match-game/matchGameService.service';
import { TriviaGameService } from '../trivia-game/triviaGameService.service';
import { routeService } from '../route-service.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  // @Input() game;
  @Input() board;
  game;

  constructor(private router: Router, private routeService: routeService, private gamePlayService: GamePlayService, private matchGameService: MatchGameService, private triviaGameService: TriviaGameService) { }

  ngOnInit(): void {
    this.game = this.gamePlayService.game;
  }

  home() {
    // let prevUrl = this.routeService.previousUrl;
    let lastUrl = document.getElementById('chooseGame');
    let lastUrlList = document.getElementById('chooseGameList');
    if (lastUrlList) {
      lastUrl = lastUrlList;
    }

    lastUrl.style.display = 'block';
    lastUrl.classList.add('slide-in');
    // if (prevUrl == '/choose' || prevUrl == '/leader-board-list') {
    if (this.game.kind == 'match') {
      setTimeout(() => {
        this.matchGameService.resetMatch();
        this.gamePlayService.resetGame();
        this.router.navigate(['choose']);
        let logo_match_anim: any = document.getElementById('logo-match-anim');
        logo_match_anim.seek(1);
      }, 600);
    } else if (this.game.kind == 'trivia') {
      setTimeout(() => {
        this.triviaGameService.resetTrivia();
        this.gamePlayService.resetGame();
        this.router.navigate(['choose']);
        let logo_trivia_anim: any = document.getElementById('logo-trivia-anim');
        logo_trivia_anim.seek(1);
      }, 600);
    } else {
      this.gamePlayService.resetGame();
      this.router.navigate(['choose']);
    }
    // } else if (prevUrl == '/match-game/mitanim' || prevUrl == '/match-game/nosaim' || prevUrl == '/trivia-game/mitanim' || prevUrl == '/trivia-game/nosaim') {
    // let lastUrl = document.getElementById('chooseGame');
    // lastUrl.style.display = 'block';
    // lastUrl.classList.add('slide-in');
    // console.log(lastUrl);

    // setTimeout(() => {
    //   this.router.navigate(['choose']);
    // }, 1200);
    // }
    // else if () {

    // }
    // else if (prevUrl == '/trivia-game/mitanim') {

    // } 
    // else {
    // let lastUrl = document.getElementById('chooseGame');
    // if (lastUrl) {
    //   lastUrl.style.display = 'block';
    //   lastUrl.classList.add('slide-in');
    // }
    // this.gamePlayService.resetGame();
    // this.router.navigate(['choose']);
    // }
    // } else if (this.game.kind == 'trivia') {
    // } else {
    // }
  }

  back() {
    if (this.routeService.previousUrl) {
      let lastUrl;
      if (this.game.kind == 'match') {
        lastUrl = document.getElementById('matchGame');
      } else if (this.game.kind == 'trivia') {
        lastUrl = document.getElementById('triviaGame');
      }
      lastUrl.style.display = 'block';
      lastUrl.classList.add('slide-in');
      setTimeout(() => {
        this.router.navigate([this.routeService.previousUrl]);
      }, 600);
    } else {
      this.router.navigate(['/']);
    }

  }
}
